/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.57
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ArticleEntity from './ArticleEntity';

/**
 * The ArticlesMediaEntity model module.
 * @module model/ArticlesMediaEntity
 * @version 1.0.1
 */
export default class ArticlesMediaEntity {
  /**
   * Constructs a new <code>ArticlesMediaEntity</code>.
   * @alias module:model/ArticlesMediaEntity
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ArticlesMediaEntity</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ArticlesMediaEntity} obj Optional instance to populate.
   * @return {module:model/ArticlesMediaEntity} The populated <code>ArticlesMediaEntity</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ArticlesMediaEntity();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('tag'))
        obj.tag = ApiClient.convertToType(data['tag'], 'String');
      if (data.hasOwnProperty('article'))
        obj.article = ArticleEntity.constructFromObject(data['article']);
      if (data.hasOwnProperty('mediaType'))
        obj.mediaType = ApiClient.convertToType(data['mediaType'], 'Number');
      if (data.hasOwnProperty('mediaUrl'))
        obj.mediaUrl = ApiClient.convertToType(data['mediaUrl'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ArticlesMediaEntity.prototype.id = undefined;

/**
 * @member {String} tag
 */
ArticlesMediaEntity.prototype.tag = undefined;

/**
 * @member {module:model/ArticleEntity} article
 */
ArticlesMediaEntity.prototype.article = undefined;

/**
 * @member {Number} mediaType
 */
ArticlesMediaEntity.prototype.mediaType = undefined;

/**
 * @member {String} mediaUrl
 */
ArticlesMediaEntity.prototype.mediaUrl = undefined;

